import { DownloadIllustrationIcon } from '@weblite/icons'
import { InstallTwaLayout } from '$common/install-twa-layout'
import { t } from '$i18n'

export function ForceInstallTwa({ isOpen }: { isOpen: boolean }) {
  return (
    <InstallTwaLayout
      isFullScreen
      isOpen={isOpen}
      icon={
        <DownloadIllustrationIcon
          sx={{ width: '240px', height: '180px', margin: 'auto' }}
        />
      }
      title={t('installTwa.force.title')}
      description={t('installTwa.force.description')}
    />
  )
}
